module.exports = __webpack_public_path__ + "static/media/FK.5a1d0c79.svg";